import type { UseFormReturn } from 'react-hook-form';
import { DESCRIPTION_MAX_LENGTH, type CreateProjectFormData } from '@/entities/project';
import type { ProjectPrefill } from '../api/prefillProjectFromDocuments';

const SET_OPTS = { shouldValidate: true, shouldDirty: true } as const;

export function applyPrefill(
  form: UseFormReturn<CreateProjectFormData>,
  prefill: ProjectPrefill,
): void {
  if (prefill.title) form.setValue('title', prefill.title, SET_OPTS);
  if (prefill.description) {
    form.setValue('description', prefill.description.slice(0, DESCRIPTION_MAX_LENGTH), SET_OPTS);
  }
  if (prefill.type) form.setValue('type', prefill.type, SET_OPTS);
  if (prefill.market) form.setValue('markets', [prefill.market], SET_OPTS);
}
